import { useEffect } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  Stack,
  useDisclosure
} from "@chakra-ui/react";
import { Form, Select } from "antd";
import { BiSlider } from "react-icons/bi";
import useFilterAvancado from "../../hooks/useFilterAvancado";
import styled from "styled-components";
import { FiltrosAvancado } from "../../interfaces/Planejamento";
import { useFilters } from "core/features/filters/store";
import useTalhoesStore from "../maps/base-map/hooks/useTalhoesStore";

type Props = {
  filtersData?: FiltrosAvancado;
}

const { Item, useForm } = Form;

export function FiltrosAvancados({ filtersData }: Props) {
  const [form] = useForm();
  const { setClasseOperacao, setCultura, setPeriodo } = useFilterAvancado();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { filters, updateField } = useFilters();
  const { filtersAdvanced } = filters;
  const { planoOperacionalIds, setPlanoOperacionalIds } = useTalhoesStore();

  const culturaOptions = (filtersData?.ocupacoes || []).map((item: any) => ({
    label: item.nome,
    value: item.ocupacaoId,
  }));

  const operacaoOptions = (filtersData?.operacaoClasses || []).map((item: any) => ({
    label: item.descricao,
    value: item.operacaoClasseId,
  }));

  const activeFiltersCount = [
    !!filtersAdvanced?.cultura,
    !!filtersAdvanced?.classeOperacao?.length,
  ].filter(Boolean).length;

  function handleSearch() {
    const body = form.getFieldsValue();
    let classOperacao = body.operacao ?? filtersAdvanced.classeOperacao

    setClasseOperacao(body.operacao);
    setCultura(body.cultura);
    const obj = {
      ...filtersAdvanced,
      cultura: body.cultura ?? filtersAdvanced.cultura,
      classeOperacao: classOperacao
    }
    updateField("filtersAdvanced", obj);

    const encontrados = planoOperacionalIds.filter((plano: any) =>
      plano.operacaoClasseIds?.some((classeId: any) =>
        classOperacao.includes(classeId)
      ));
    setPlanoOperacionalIds(encontrados);
    onClose();
  }

  function handleClear() {
    setClasseOperacao('');
    setCultura('');
    setPeriodo('');
    updateField("filtersAdvanced", {
      ...filtersAdvanced,
      cultura: '',
      classeOperacao: [],
    });
    form.resetFields();
    setPlanoOperacionalIds([]);
  }

  useEffect(() => {
    if (!filtersAdvanced?.cultura && !filtersAdvanced?.classeOperacao) {
      form.resetFields();
    }
  }, [!filtersAdvanced?.cultura, !filtersAdvanced?.classeOperacao]);

  return (
    <Popover placement="bottom-start" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
      <PopoverTrigger>
        <ButtonSliderWrapper>
          {activeFiltersCount > 0 && <IconCircle>{activeFiltersCount}</IconCircle>}
          <BiSlider />
        </ButtonSliderWrapper>
      </PopoverTrigger>
      <Form
        form={form}
        layout="vertical"
      >
        <PopoverContent p={4} w="sm">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">Filtros Avançados</PopoverHeader>
          <PopoverBody>
            <Stack spacing={2}>
              <Wrap>
                <Item label="Cultura" name="cultura">
                  <SelectAntd
                    allowClear
                    placeholder="Cultura"
                    options={culturaOptions}
                    defaultValue={filtersAdvanced?.cultura}
                  />
                </Item>
              </Wrap>
              <Wrap>
                <Item label="Classe de Operação" name="operacao">
                  <SelectAntd
                    allowClear
                    showSearch
                    mode="multiple"
                    maxTagCount={2}
                    optionFilterProp="label"
                    options={operacaoOptions}
                    placeholder="Classe de Operação"
                    defaultValue={filtersAdvanced?.classeOperacao}
                    maxTagPlaceholder={(omittedValues) => <span>+{omittedValues.length}</span>}
                  />
                </Item>
              </Wrap>
            </Stack>
          </PopoverBody>
          <PopoverFooter display="flex" justifyContent="space-between">
            <Button variant="ghost" onClick={handleClear}>Limpar</Button>
            <Button colorScheme="green" onClick={handleSearch}>Aplicar</Button>
          </PopoverFooter>
        </PopoverContent>
      </Form>
    </Popover>
  );
}

const ButtonSliderWrapper = styled.button`
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    min-width: 45px;
    height: 60px;

    svg {
      font-size: 20px;
    }

    :active {
        background: #20a45a;
        border-color: #20a45a;
    }
`;

const Wrap = styled.div`
    width: 100%;

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-col {
      padding: 0;
    }
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

const IconCircle = styled.span`
  width: 16px;
  height: 16px;
  position: absolute;
  top: 2px;
  right: 1px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;`